import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Cascader} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Cascader, {
            'data': this.get('data'),
            'disabled': true
        }),
        _$cc(Cascader, {
            'data': this.get('data')
        })
    ], 4 /* HasNonKeyedChildren */);
};